import { render, staticRenderFns } from "./PosAdd.vue?vue&type=template&id=235e8019&scoped=true"
import script from "./PosAdd.vue?vue&type=script&lang=js"
export * from "./PosAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e8019",
  null
  
)

export default component.exports